import './styles.css';
import Editor from './Editor';
import { useRef } from 'react';
import { useFormContext } from 'react-hook-form';
import { ErrorMessage } from '../ErrorMessage';

interface IRichTextEditor {
  onChange?: any;
  value: any;
  errorInfo?: string;
  fieldName?: string;
  readOnly?: boolean;
  toolbarOptions?: unknown[];
  className?: string;
  placeholder?: string;
}

export const RichTextEditor = ({
  onChange,
  value,
  errorInfo,
  fieldName,
  readOnly = false,
  toolbarOptions,
  className,
  placeholder,
}: IRichTextEditor) => {
  const quillRef = useRef();

  const {
    formState: { errors },
  } = useFormContext() ?? { formState: { errors: [] } };

  let error = fieldName?.length! > 0 ? errors[fieldName as string]?.message?.toString() : [];

  if (error === undefined) {
    error = errorInfo;
  }

  return (
    <>
      <Editor
        readOnly={readOnly}
        ref={quillRef}
        defaultValue={value}
        onTextChange={onChange}
        onSelectionChange={undefined}
        toolbarOptions={toolbarOptions}
        className={className}
        placeholder={placeholder}
      ></Editor>
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </>
  );
};
